import { client, CONTENT_BASE_URL } from "@/api/client.ts";
import { APP_ID } from "@/env.ts";

export type Translations = Record<string, string>;

export const getTranslations = (language: string) => {
  return client
    .get<Translations>(
      `${CONTENT_BASE_URL}/api/v2/translations/${APP_ID}/${language}`,
      {},
    )
    .then((data) => data.data);
};
